export const MIN_PASSWORD_LENGTH = 8;

export const ERR_MESSAGE_MIN_PASSWORD_LENGTH = `Password must have at least ${MIN_PASSWORD_LENGTH} characters!`;
export const ERR_MESSAGE_PASSWORD_DONT_MATCH = 'Repeated password doesn\'t match the new password!';



// WEBPACK FOOTER //
// ./src/containers/myaccount/forms/constants.js